import React, { HTMLAttributes } from 'react'
import { useNavigate } from 'react-router'
import { Nav } from 'rsuite'

type Props = {
  id: string,
  link?: string,
  name: string,
  icon: React.FunctionComponent<HTMLAttributes<SVGElement>>,
  active?: boolean,
  disabled?: boolean
}
const NavItem = ({ id, link, name, icon: Icon, active, disabled }: Props) => {
  const navigate = useNavigate()

  return (
    <Nav.Item
      eventKey={id}
      className={active ? 'active' : ''}
      onClick={() => link && navigate(link)}
      icon={<Icon className="rs-sidenav-item-icon rs-icon" />}
      disabled={disabled}
    >
      <span className="sidenav-item__text">{name}</span>
    </Nav.Item>
  )
}
export default NavItem
